import tinycolor from 'tinycolor2'

export const isValidHex = (hex: string) => {
  const hashLength = hex.startsWith('#') ? 1 : 0
  const length = hex.length - hashLength

  // Disable hex4 and hex8
  const validLength = length !== 4 && length < 7

  return validLength && tinycolor(hex).isValid()
}

export const toHex = (color?: string) => {
  return tinycolor(color)
    .toHex()
    .toUpperCase()
}

export const toHexString = (color?: string) => {
  return tinycolor(color)
    .toHexString()
    .toUpperCase()
}
